// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3dnJ-","errors":"Errors_errors__2sgrB"};